import classNames from "classnames";
import { ChevronDown, Search } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";

export default function DropdownWithSearch({
  placeholder,
  children,
  showSearch = false,
  isErrorState = false,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOutsideClick = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);
  return (
    <div
      className={`docpro_dropdown_with_search_wrap ${isOpen ? "active" : ""}`}
      ref={dropdownRef}
    >
      <div
        className={classNames("docpro_dropdown_with_search_btn", {
          danger_alert: isErrorState,
        })}
        onClick={toggleDropdown}
      >
        {placeholder} <ChevronDown width={20} height={20} />
      </div>
      {isOpen && (
        <div className="docpro_dropdown_with_search_body custom-scroll">
          {showSearch && (
            <form className="docpro_search_form">
              <input
                type="text"
                placeholder="Search"
                className="docpro_search_input"
              />
              <button className="docpro_search_btn">
                <Search width={20} height={20} />
              </button>
            </form>
          )}
          {children}
        </div>
      )}
    </div>
  );
}
